/* eslint-disable @typescript-eslint/no-unused-vars */
import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { StorageService } from './storage.service';
import { AppSettings } from './../app.settings';
@Injectable()
export class AuthenticationValidationService  {

  constructor(private storageService: StorageService, private router: Router) { }

  //** Dont remove commented/unused code/arguments */
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.storageService.getItemFromCookies(AppSettings.TOKEN_KEY)) {
      return true;
    }
    this.router.navigate(['/signin']);
    return false;
  }
}
